import { useState } from 'react'
import moment from 'moment'

import { DatePicker } from '@components/TimePicker'
import { CardSection } from '@components/CardSection'
import Button from '@components/Button'

import { DATE_FORMAT } from 'shared/constants'
import purchaseStyles from 'subscription-flow/styles.module.scss'

const DateSelection = ({ onNext, value, isOutsideRange }) => {
    const [startDate, setStartDate] = useState(value || null)

    const onStartDateChange = momentDate => {
        setStartDate(momentDate)
    }

    const onNextClick = () => {
        onNext({ value: startDate, displayValue: startDate.format(DATE_FORMAT) })
    }

    return (
        <CardSection className={purchaseStyles.contentSection} loading={false}>
            <h3 className="text-uppercase">
                <T>subscription.purchase.start.on</T>
            </h3>
            <div className="col-sm-4 mt-6 mb-6 px-0">
                <DatePicker
                    label={<T>label.parking.start</T>}
                    value={startDate ? moment(startDate) : ''}
                    displayFormat={DATE_FORMAT}
                    onChange={onStartDateChange}
                    isOutsideRange={isOutsideRange}
                />
            </div>
            <div className="d-flex justify-content-end">
                <Button btnStyle="primary" onClick={onNextClick} disabled={!startDate}>
                    <T>subscription.purchase.label.next</T>
                </Button>
            </div>
        </CardSection>
    )
}

export default DateSelection
